import createAPI from './hotel-api';


const credentialsConf = {
  withCredentials: true,
};

const api = createAPI(process.env.MUJI_APP_HOST, {
  showNotification: true,
});

export function debugApi(payload) {
  return api.postJson('/portal/api/v2/debug/api', payload, credentialsConf);
}
